import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface ApiResultModel {
    documentCollection: DocumentModel[];
    search?: string | undefined;
    properties?: any;
    uri?: string;
    errorMessage?: string;
}

export interface DocumentModel {
    documentName: string;
    documentPath: string;
}
export interface TECDocumentsSearchParameter extends ApiParameter {
    search?: string;
}

const url = "/api/v1/documents";

export async function getDocumentsFromApi(search: TECDocumentsSearchParameter) {
    const response = await get<ApiResultModel>(`${url}`, search);
    return response;
}
